import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import SubmitButton from "../../../../components/SubmitButton";
import ValidationForm from "../../../../components/ValidationForm";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {Spinner} from "react-bootstrap";
import {Typeahead} from "react-bootstrap-typeahead";
import {networkResetDeviceActions} from "../../../../actions/network-reset-device.actions";

class NetworkResetDeviceForm extends Component {

    state = {
        form: {
            id: null,
            networkDeviceId: null,
            resetatorId: null,
            resetCount: 3,
            resetIntervalSeconds: 180,
            resetator: {
                id: null,
                label: "",
                description: "",
                ipAddress: "",
                port: 0,
                mac: "",
                diagnosticMode: false,
            },
            networkDevice: null,
        },
        isEdit: false,
        selectedList: []
    }

    componentDidMount() {
        const { dispatch, data } = this.props;
        dispatch(networkDeviceActions.getDropDownList());

        if(data) {
            console.log(data);
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    networkDeviceId: data.networkDeviceId,
                    resetatorId: data.resetatorId,
                    resetCount: data.resetCount,
                    resetIntervalSeconds: data.resetIntervalSeconds,
                    resetator: {
                        id: data.resetator.id,
                        label: data.resetator.label,
                        description: data.resetator.description,
                        ipAddress: data.resetator.ipAddress,
                        port: data.resetator.port,
                        mac: data.resetator.mac,
                        diagnosticMode: data.resetator.diagnosticMode,
                    },
                    networkDevice: data.networkDevice,
                }
            })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.dropdownList !== this.props.dropdownList && this.props.dropdownList !== null) {
            let selected = [];

            if(this.state.form.networkDevice) {
                selected.push(this.props.dropdownList.find((x) => x.id === this.state.form.networkDeviceId))
            }

            this.setState({
                ...this.state,
                selectedList:selected
            })
        }
    }

    handleOnChangeInput = (e) => {
        const property = e.target.getAttribute('data-property');
        property ?
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    [property]: {
                        ...this.state.form[property],
                        [e.target.name]: e.target.value,
                    }
                }
            }
        ) :
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    [e.target.name]: e.target.value
                }
            });
    }

    handleOnChangeCheckbox = (e) => {
        const property = e.target.getAttribute('data-property');

        property ?
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    [property]: {
                        ...this.state.form[property],
                        [e.target.name]: e.target.checked
                    }
                }
            }) :
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    [e.target.name]: e.target.checked
                }
            })
    }

    handleChangeNetworkDevice = (networkDevice) => {
        const firstNetworkDevice = networkDevice[0];
        this.setState({
            ...this.state,
            selectedList: networkDevice,
            form: {
                ...this.state.form,
                networkDevice: firstNetworkDevice ? firstNetworkDevice : null,
                networkDeviceId: firstNetworkDevice ? firstNetworkDevice.id  : 0
            }
        })

    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { dispatch } = this.props;

        if(this.state.selectedList.length > 0) {

            if (this.state.isEdit) {
                dispatch(networkResetDeviceActions.editDevice(this.state.form));
            }
            else {
                dispatch(networkResetDeviceActions.createDevice(this.state.form));
            }
        }

        else {
            //todo:  toaster
        }
    }

    render() {
        const { t, validationForm, dropdownList } = this.props;
        const { form } = this.state;

        console.log(dropdownList);

        const networkDeviceSelect = dropdownList ? (
            <Typeahead
                id="network-device-list"
                inputProps={{ required: true }}
                labelKey={options => {
                    return options.label || ""
                }}
                selected={this.state.selectedList}
                onChange={ (selected) => this.handleChangeNetworkDevice(selected) }
                options={dropdownList}
                required
            />
        ) : (<div><Spinner animation={"border"} /></div>)

        return (
           <form onSubmit={this.handleSubmit}>
               <div className="row">
                   <h5 className="col-md-12">{t('network-reset-device-single')} <hr/> </h5>
               </div>
               <div className="row">
                   <div className="col-md-6">
                       <div className="form-group">
                           <label htmlFor="label"> {t('label')} </label>
                           <input
                               type="text"
                               className={`form-control ${validationForm?.errorMessages['Label'] ? "is-invalid" : ''}`}
                               data-property="resetator"
                               name="label"
                               value={form.resetator.label}
                               onChange={this.handleOnChangeInput}
                               required
                           />
                       </div>

                       <div className="form-group">
                           <label className="col-form-label" > {t('ip-address')} </label>
                           <input
                               type="text"
                               className={`form-control ${validationForm?.errorMessages['IpAddress'] ? "is-invalid" : ''}`}
                               data-property="resetator"
                               name="ipAddress"
                               minLength="7"
                               maxLength="15"
                               size="15"
                               pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"
                               value={form.resetator.ipAddress}
                               onChange={this.handleOnChangeInput}
                               required
                           />
                           <ValidationForm validationKey={validationForm?.errorMessages['IpAddress']}/>
                       </div>

                       <div className="form-group ">
                           <label  className="col-form-label" > {t('mac')} </label>
                           <input
                               type="text"
                               className={`form-control ${validationForm?.errorMessages['Mac'] ? "is-invalid" : ''}`}
                               data-property="resetator"
                               name="mac"
                               value={form.resetator.mac}
                               onChange={this.handleOnChangeInput}/>
                           <ValidationForm validationKey={validationForm?.errorMessages['Mac']}/>
                       </div>

                       <div className="form-group">
                           <label className="col-form-label" > {t('description')} </label>
                           <textarea
                               className="form-control"
                               name="description"
                               data-property="resetator"
                               title="Description"
                               value={form.description}
                               onChange={this.handleOnChangeInput}  />
                       </div>

                       <div className="form-group">
                           <label className="col-form-label"> {t('diagnostic-mode')} </label>
                           <input
                               type="checkbox"
                               className="form-check"
                               data-property="resetator"
                               name="diagnosticMode"
                               checked={form.diagnosticMode}
                               onChange={this.handleOnChangeCheckbox} />
                       </div>
                       <hr/>
                   </div>

                   <div className="col-md-6">

                       <div className="form-group">
                           <label className="col-form-label"> {t('reset-count')} </label>
                           <input
                            type="number"
                            className="form-control"
                            name="resetCount"
                            value={form.resetCount}
                            onChange={this.handleOnChangeInput}
                            required
                           />
                       </div>

                       <div className="form-group">
                           <label className="col-form-label"> {t('reset-interval-seconds')} </label>
                           <input
                               type="number"
                               className="form-control"
                               name="resetIntervalSeconds"
                               value={form.resetIntervalSeconds}
                               onChange={this.handleOnChangeInput}
                               required
                           />
                       </div>

                       <div className="form-group">
                           <div className="form-group">
                               <label className="col-form-label">{ t('network-device-to-reset-device') }</label>
                               { networkDeviceSelect }
                           </div>
                       </div>
                   </div>

               </div>
               <div className="col-md-6">
                   <div className="mt-4 form-group">
                       <SubmitButton type={this.state.isEdit} />
                   </div>
               </div>
           </form>
        )
    }

}
const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    const { dropdownList } = state.networkDeviceReducer;
    return {
        user,
        dropdownList
    }
}
export default withNamespaces()(connect(mapStateToProps)(NetworkResetDeviceForm))
